import { ReactNode } from 'react'

type Props = {
  header: string
  text: string
  width?: number
}

const parseText = (text: string): ReactNode[] =>
  text
    .split(/(<highlight>.*?<\/highlight>|<border>.*?<\/border>)/g)
    .map((part, i) => {
      const h = part.match(/^<highlight>(.*?)<\/highlight>$/)
      if (h) {
        return (
          <span
            key={i}
            style={{
              display: 'inline-block',
              padding: '1px 3px',
              borderRadius: '3.2px',
              border: '1.6px solid #FF7AE9',
              background: '#FF7AE9',
            }}
          >
            {h[1]}
          </span>
        )
      }
      const b = part.match(/^<border>(.*?)<\/border>$/)
      if (b) {
        return (
          <span
            key={i}
            style={{
              display: 'inline-block',
              padding: '1px 3px',
              borderRadius: '3.2px',
              border: '1.6px solid #FF7AE9',
            }}
          >
            {b[1]}
          </span>
        )
      }
      return part
    })

const MessageCard = ({ header, text, width = 203 }: Props) => (
  <div style={{ position: 'relative', paddingTop: 12, width }}>
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 14,
        display: 'flex',
        height: 19,
        padding: '5px 8px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 4,
        borderRadius: 2,
        backgroundColor: '#E0C797',
      }}
    >
      <img src="/images/email.svg" alt="" style={{ width: 12, height: 12 }} />
      <span
        style={{
          fontSize: 10,
          fontWeight: 600,
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
          color: '#540037',
          whiteSpace: 'nowrap',
        }}
      >
        {header}
      </span>
    </div>

    <div
      style={{
        padding: 12,
        borderRadius: 12,
        background: '#FFF',
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        color: '#540037',
        fontWeight: 600,
        fontSize: '1rem',
        lineHeight: 1.5,
      }}
    >
      {parseText(text)}
    </div>
  </div>
)

export default MessageCard
